import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Inject,
  Input,
  LOCALE_ID,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';
import {formatDate} from '@angular/common';
import {Unit} from '../dashboard/monitoring/unit';
import * as L from 'leaflet';
import {latLng, LatLng, Map, Marker, Point, polyline, Popup} from 'leaflet';
import {BehaviorSubject, combineLatest, Observable, of, Subject, Subscription, timer} from 'rxjs';
import * as moment from 'moment-timezone';
import {
  concatMap,
  delay,
  distinctUntilChanged,
  distinctUntilKeyChanged,
  expand,
  filter,
  map,
  share,
  switchMap,
  tap,
  withLatestFrom
} from 'rxjs/operators';
import {HttpClient, HttpParams} from '@angular/common/http';
import {CSVG} from '../shared/CSVG';
import {MapHelper} from '../shared/map.helper';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {SwiperConfigInterface} from 'ngx-swiper-wrapper';
import {ImmutableListRepositoryService} from '../../lib/gelios-field/immutable-list-repository.service';
import {LbsYandexModel} from '../dashboard/monitoring/lbs-yandex.model';
import {NotificationsService} from 'angular2-notifications';
import {UnitStatusManagerService} from '../unit-status-manager/unit-status-manager.service';
import {UnitStatusModel} from '../unit-status-manager/unit-status.model';
import {ModalWindowService} from '../shared/modal-window/modal-window.service';
import {ModalWindowType} from '../shared/modal-window/modal-window-type';
import * as lodash from 'lodash';
import {FormBuilder} from '@angular/forms';
import {ModalWindowResponse} from '../shared/modal-window/modal-window-response';
import {RouteLibraryService} from '../route/route-library.service';
import {MainLightboxService} from '../layout/main-lightbox.service';
import {MapWidgetService} from '../shared/map-widget/map-widget.service';
import {MapService} from '../shared/map.service';
import {AuthorizationService} from '../authorization/authorization.service';
import {MobileViewService, SettingWindowOptionsService} from 'gelios-ng-admin-components';
import {environment} from '../../environments/environment';
import {MapTileLayerSettingsService} from '../map-settings/map-services/map-tile-layer-settings.service';
import {UnitCardDataService} from './unit-card-data.service';
import {EndUserImage} from '../end-user/models/end-user.model';
import {UnitMessageService} from './unit-message-service/unit-message.service';
import {ImageGroupModel} from './image-group.model';
import {UnitCardTabTypes} from './unit-card.model';
import {RouteLibraryEntities} from '../route/route-library-entity';
import {TabVisibilityManager} from '../shared/card-view/card-view-tab/tab-visibility-manager.component';
import {UnitDemandModel} from '../dashboard/monitoring/unit-demand.model';
import {UnitReflexiveModel} from '../unit/unit.reflexive.model';

@Component({
  selector: 'app-unit-card',
  templateUrl: './unit-card.component.html',
  styleUrls: ['./unit-card.component.scss'],
  providers: [
    {
      provide: MapTileLayerSettingsService,
      useClass: MapTileLayerSettingsService
    },
  ]
})
export class UnitCardComponent implements OnInit, OnDestroy, AfterViewInit {
  public readonly unitTypeIot = Unit.UNIT_TYPE_IOT;
  public readonly unitTypeCar = Unit.UNIT_TYPE_CAR;
  public readonly unitTypeChargingStation = Unit.UNIT_TYPE_CHARGING;
  public readonly trackPeriodHour = 'hour';
  public readonly trackPeriodDay = 'day';
  public readonly trackPeriodWeek = 'week';
  public readonly trackPeriod30Days = '30-days';
  protected readonly UnitCardTabTypes = UnitCardTabTypes;
  protected readonly RouteLibraryEntities = RouteLibraryEntities;
  @ViewChild('heightWidget') heightWidget: ElementRef;
  @ViewChild('statusPopup') statusPopup: ElementRef;
  @HostBinding('class.card-container') cardContainer;
  @ViewChild('unitLog') unitLog: ElementRef;
  pollDataSubscription: Subscription;
  refreshInterval = 7000;
  @Output() loadingEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  public unitLogHeight: BehaviorSubject<number> = new BehaviorSubject<number>(280);
  @Input() showHeader: boolean;
  unitStatusVisibility = false;
  unitStatus: Observable<string>;
  latestOrderPhotos: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>(null);
  unitDemands: Observable<UnitDemandModel[]>;
  btnWriteOffIsOpened = false;

  get changeUnitStatusAccess() {
    return this.unit.model_access_rights.changeStatus;
  }

  locatorAccess(): Observable<boolean> {
    return this.authorizationService.checkAccess('locator', AuthorizationService.ACTION_CREATE);
  }

  get speed(): number {
    return this.unit.lastMsgUnit ? this.unit.lastMsgUnit.speed : null;
  }

  get btnWriteOffIsVisible() {
    return !this.unit.written_off
      && this.unit.legal_entity_id !== null && this.unit.legal_entity_id !== undefined
      && this.unit.branch_office_id !== null && this.unit.branch_office_id !== undefined
      && this.unit.businessLogics
      && this.unit.businessLogics.length > 0
      && this.unit.businessLogics.some(el => el.type === AuthorizationService.BUSINESS_LOGIC_TYPE_COURIER);
  }

  imageGroup: Observable<any>;

  get unitStatusIcon(): string {
    let iconName = 'map-unit-icon ';
    switch (this.unit.status_connection) {
      case Unit.STATUS_CONNECTION_OFFLINE:
        iconName += 'status-offline';
        break;
      case Unit.STATUS_CONNECTION_ONLINE:
        iconName += 'status-online';
        break;
      case Unit.STATUS_CONNECTION_ONLINE_RECENTLY:
        iconName += 'status-online-recently';
        break;
      case Unit.STATUS_CONNECTION_ONLINE_LATELY:
        iconName += 'status-online-lately';
        break;
    }
    iconName += ' ' + MapHelper.getUnitIconClass(this.unit.unitModel.unit_type_name);
    return iconName;
  }

  get unitIsOnline(): boolean {
    return this.unit.status_connection === 'online';
  }

  get sendingCommandsIsAvailable(): boolean {
    return this.unit.model_access_rights.sendCommand
      && (this.unitHasInternalMonitoringModule || this.unitHasExternalMonitoringModule);
  }

  get unitHasInternalMonitoringModule(): boolean {
    return this.unit.monitoring_module_attachment_type_id === UnitReflexiveModel.monitoringModuleAttachmentTypeIdInternal;
  }

  get unitHasExternalMonitoringModule(): boolean {
    return !!this.unit.attachedUnit;
  }

  get unitIsInRent(): boolean {
    return this.unit.status_order === Unit.STATUS_ORDER_BOOKED
      || this.unit.status_order === Unit.STATUS_ORDER_ACTIVE
      || this.unit.status_order === Unit.STATUS_ORDER_PAUSED;
  }

  endUserId: Observable<number>;
  endUserImage: Observable<EndUserImage>;

  get unitChargeLevelIcon(): string {
    let iconChargeName = 'charge-level ';
    if (this.unit.lastMsgUnit && this.unit.lastMsgUnit.charge) {
      if (Unit.chargeIsAlarm(this.unit)) {
        iconChargeName += ' charge-state-low-secondary';
      } else if (Unit.chargeIsWarning(this.unit)) {
        iconChargeName += ' charge-state-middle_warning-secondary';
      } else if (Unit.chargeIsOk(this.unit)) {
        iconChargeName += ' charge-state-middle-secondary';
      } else {
        iconChargeName += ' charge-state-high-secondary';
      }
    } else {
      iconChargeName += ' charge-state-low-secondary';
    }
    return iconChargeName;
  }

  get unitPlateNumber(): string {
    return this.unit.plate_number ? this.unit.plate_number : this.translates.instant('not set');
  }

  get unitLatLon(): string {
    return this.unit.lastMsgUnit ? this.unit.lastMsgUnit.lat + ',' + this.unit.lastMsgUnit.lon : null;
  }

  get colorName(): string {
    return this.unit.color_name ? this.unit.color_name : 'color not set';
  }

  get htmlColor(): string {
    return this.unit.html_color ? this.unit.html_color : '#a0a0a0';
  }

  get orderModel() {
    return this.unit.activeOrder;
  }

  get endUserName(): string {
    return (this.unit.activeOrder && this.unit.activeOrder.endUser) ?
      (this.unit.activeOrder.endUser.first_name ? this.unit.activeOrder.endUser.first_name : '')
      + (this.unit.activeOrder.endUser.middle_name ? ' ' + this.unit.activeOrder.endUser.middle_name : '')
      + (this.unit.activeOrder.endUser.last_name ? ' ' + this.unit.activeOrder.endUser.last_name : '')
      : '';
  }

  @Input() unitViewMode = false;

  get unitType(): string {
    return this.unit.unitType.name;
  }

  get unitCharge(): string {
    return this.unit.lastMsgUnit ? this.unit.lastMsgUnit.charge.toString() : '';
  }

  get lockIsClosed(): boolean {
    return this.unit.lastMsgUnit ? this.unit.lastMsgUnit.lock_is_closed : null;
  }

  get headIsOn(): boolean {
    return this.unit.lastMsgUnit ? this.unit.lastMsgUnit.head_is_on : null;
  }

  get brakeIsOn(): boolean {
    return this.unit.lastMsgUnit ? this.unit.lastMsgUnit.brake_is_on : null;
  }

  get flashlightIsOn(): boolean {
    return this.unit.lastMsgUnit ? this.unit.lastMsgUnit.flashlight_is_on : null;
  }

  get serviceModeIsOn(): boolean {
    return this.unit.lastMsgUnit ? this.unit.lastMsgUnit.service_mode_is_on : null;
  }

  get speedMode(): string {
    return this.unit.lastMsgUnit ? this.unit.lastMsgUnit.speed_mode : null;
  }


  public unitBehaviorSubject: BehaviorSubject<Unit> = new BehaviorSubject<Unit>(null);

  @Input() unitId: BehaviorSubject<number>;

  get unit() {
    return this.unitBehaviorSubject.getValue();
  }

  @Input() lbsYandex: BehaviorSubject<LbsYandexModel> = new BehaviorSubject<LbsYandexModel>(null);
  public leafletLbsCircle: BehaviorSubject<L.Circle> = new BehaviorSubject<L.Circle>(null);
  availableStatuses: Observable<Array<UnitStatusModel>>;
  status: number;
  selectedTrackPeriod: string | null = null;
  trackTime: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([null, null]);
  disableTrackTime = false;

  @Output() searchByLbsClickEmitter: EventEmitter<Unit> = new EventEmitter<Unit>();
  tabManager = new TabVisibilityManager<UnitCardTabTypes>({
    [UnitCardTabTypes.Rates]: false,
    [UnitCardTabTypes.Subscriptions]: false,
    [UnitCardTabTypes.GeneralInfo]: false,
    [UnitCardTabTypes.Battery]: false,
    [UnitCardTabTypes.Command]: false,
    [UnitCardTabTypes.Locator]: false,
    [UnitCardTabTypes.UnitLog]: false,
    [UnitCardTabTypes.LatestPhotos]: false,
    [UnitCardTabTypes.LastOrder]: false,
    [UnitCardTabTypes.Demand]: false,
    [UnitCardTabTypes.Groups]: false,
  });

  orderDescription = false;
  map: Map;
  leafletMapReady = new Subject();
  marker: BehaviorSubject<Marker> = new BehaviorSubject(null);
  useGPSCoords: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  useWiFiCoords: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  useLBSCoords: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  enableTrackFilter: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  trackMessages: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
  track = combineLatest(
    this.trackMessages,
    this.useGPSCoords,
    this.useLBSCoords,
    this.useWiFiCoords,
  ).pipe(
    map(([trackMessages, useGPSCoords, useLBSCoords, useWiFiCoords]) => trackMessages.filter(
      m => (m.coordType === 'gps' && useGPSCoords) || (m.coordType === 'lbs' && useLBSCoords) || (m.coordType === 'wifi' && useWiFiCoords)
    )),
    map(c => {
      if (c.length < 2) {
        return null;
      }
      const p = polyline(
        c.map(m => new LatLng(m.lat, m.lon)),
        {
          renderer: new CSVG(),
          className: 'track-polyline',
          lineJoin: 'round',
          color: '#0F245A',
          weight: 4,
          smoothFactor: 0,
        }
      );
      p.on('click', (e) => {
        this.onTrackClick(e);
      });
      this.map.fitBounds(p.getBounds());
      return p;
    })
  );
  trackDistance = this.trackMessages.pipe(
    filter(m => m !== null && m.length > 1),
    withLatestFrom(this.unitBehaviorSubject),
    map(([m, unit]) => {
      const gpsDist = m.map(v => new LatLng(v.lat, v.lon)).reduce(
        (acc, val, index, arr) => index === 0 ? acc : acc + val.distanceTo(arr[index - 1]),
        0
      );
      let result = unit.unitType.name === Unit.UNIT_TYPE_CAR ?
        (Math.round(gpsDist / 100) / 10) + ' ' + this.translates.instant('km')
        : (Math.round(gpsDist * 10) / 10) + ' ' + this.translates.instant('m');
      const regex = /mileage:([0-9.]+)/;
      const matches1 = regex.exec(m[0].params);
      const matches2 = regex.exec(m[m.length - 1].params);
      if (matches1 && matches2) {
        const mileage1 = parseFloat(matches1[1]);
        const mileage2 = parseFloat(matches2[1]);
        const mileageDist = mileage2 - mileage1;
        result = this.translates.instant('Mileage') + ': ' +
          this.translates.instant('by coordinates') + ': ' + result +
          ', ' + this.translates.instant('by odometer') + ': ' +
          (
            unit.unitType.name === Unit.UNIT_TYPE_CAR ?
              (Math.round(mileageDist * 10) / 10) + ' ' + this.translates.instant('km')
              : (Math.round(mileageDist * 10000) / 10) + ' ' + this.translates.instant('m')
          );
      }
      return result;
    })
  );
  layers: Observable<Array<L.Layer>>;
  initialLeafletZoom = 17;
  leafletOptions = {
    layers: [this.mapTileLayerSettingsService.currentTileLayer.getValue()],
    zoom: this.initialLeafletZoom,
    center: latLng(53.9, 27.55),
    zoomControl: true,
    attributionControl: false
  };

  leafletZoom = 13;

  leafletZoomOptions = {
    animate: true
  };

  swiperConfig: SwiperConfigInterface = {
    a11y: true,
    direction: 'horizontal',
    keyboard: true,
    mousewheel: true,
    scrollbar: false,
    navigation: false,
    pagination: false,
  };

  get orderTotalPrice(): number {
    return this.unit.activeOrder && this.unit.activeOrder.endUserOrderIntervals ?
      this.unit.activeOrder.endUserOrderIntervals.reduce(
        (a, i) => a + (i.total_price ? i.total_price : 0),
        0
      ) : 0;
  }

  get orderTotalMileage(): number {
    return this.unit.activeOrder && this.unit.activeOrder.endUserOrderIntervals ?
      this.unit.activeOrder.endUserOrderIntervals.reduce(
        (a, i) => a + (i.mileage ? i.mileage : 0),
        0
      ) : 0;
  }

  private subscriptions: Subscription[] = [];
  intervals = [
    {
      caption: 'Hour',
      intervalPeriod: this.trackPeriodHour,
      date: new Date().setHours(new Date().getHours() - 1),
    },
    {
      caption: 'Day',
      intervalPeriod: this.trackPeriodDay,
      date: new Date().setDate(new Date().getDate() - 1),
    },
    {
      caption: '7 days',
      intervalPeriod: this.trackPeriodWeek,
      date: new Date().setDate(new Date().getDate() - 7),
    },
    {
      caption: '30 days',
      intervalPeriod: this.trackPeriod30Days,
      date: new Date().setDate(new Date().getDate() - 30),
    },
  ];
  constructor(
    @Inject(LOCALE_ID) protected locale,
    protected http: HttpClient,
    protected unitCardDataService: UnitCardDataService,
    protected mapService: MapService,
    protected notif: NotificationsService,
    protected changeDetector: ChangeDetectorRef,
    protected translates: TranslateService,
    protected router: Router,
    public immutableListRepositoryService: ImmutableListRepositoryService,
    public mainLightboxService: MainLightboxService,
    protected unitStatusManager: UnitStatusManagerService,
    protected modalWindowService: ModalWindowService,
    protected formBuilder: FormBuilder,
    public routeLibrary: RouteLibraryService,
    private widgetService: MapWidgetService,
    protected authorizationService: AuthorizationService,
    public settingWindowOptionsService: SettingWindowOptionsService,
    protected nativeElement: ElementRef,
    public mobileView: MobileViewService,
    public mapTileLayerSettingsService: MapTileLayerSettingsService,
    protected renderer: Renderer2,
    protected unitMessageService: UnitMessageService,
  ) {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (this.unitStatusVisibility) {
        if (!this.statusPopup.nativeElement.contains(e.target)) {
          this.unitStatusVisibility = false;
        }
      }
    });
    this.unitDemands = this.unitBehaviorSubject.pipe(
      filter(u => !!u),
      map(u => u.unitDemands || []),
      map(demands => demands.filter(el =>
        el.order_count > 0 && el.businessLogicType === AuthorizationService.BUSINESS_LOGIC_TYPE_SHARING)),
    );
  }

  toggleWriteOffBtn() {
    this.btnWriteOffIsOpened = !this.btnWriteOffIsOpened;
  }

  closeWriteOffFormEvent(event: 'cancel' | 'success') {
    this.toggleWriteOffBtn();
    if (event === 'success') {
      this.stopRefresh();
      this.startRefresh(this.unit.id);
    }
  }

  activeStatusData() {
    return combineLatest(
      this.availableStatuses,
      this.unitBehaviorSubject
    ).pipe(
      filter(
        ([availableStatuses, unit]) => !!availableStatuses && !!unit
      ),
      map(([availableStatuses, unit]) => {
        return availableStatuses.find(item => item.id === unit.unit_status_id);
      })
    );
  }

  resetTrack() {
    this.selectedTrackPeriod = null;
    this.trackTime.next([null, null]);
    this.initialMapView(this.unit);
  }

  initialMapView(unit: Unit) {
    if (this.map && unit && unit.lastMsgUnit && unit.lastMsgUnit.lat !== null && unit.lastMsgUnit.lon !== null) {
      this.map.setView(L.latLng(unit.lastMsgUnit.lat, unit.lastMsgUnit.lon), this.initialLeafletZoom);
    }
  }

  ngAfterViewInit() {
    this.subscriptions.push(
      this.widgetService.contentWrapperHeight
        .pipe(
          filter(widget => widget !== null),
        )
        .subscribe(
          ({name, height}) => {
            if (name === 'unitCard' && this.heightWidget) {
              this.unitLogHeight.next(height - (this.heightWidget.nativeElement.offsetHeight - this.unitLogHeight.value));
              this.changeDetector.detectChanges();
            }
          }
        )
    );
  }

  ngOnInit() {
    this.subscriptions.push(
      this.unitId
        .pipe(
          distinctUntilChanged(),
          filter(i => i !== null)
        ).subscribe(unitId => {
        this.stopRefresh();
        this.startRefresh(unitId);
      })
    );
    this.unitStatus = this.unitBehaviorSubject.pipe(
      filter(unit => !!unit && !!unit.status_order_grid),
      map(
        unit => this.immutableListRepositoryService.getItemById(
          'status-order-grid',
          unit.status_order_grid
        )
      )
    );
    this.imageGroup = this.unitBehaviorSubject.pipe(
      filter(unit => !!unit),
      distinctUntilKeyChanged('id'),
      switchMap(
        (unit: Unit) => this.http.get<Array<ImageGroupModel>>(
          environment.apiBasepoint + 'unit/' + unit.id + '/image-group',
          {observe: 'body'}
        )
      ),
      share()
    );

    this.imageGroup.subscribe(result => {
      const arr = [];
      let imageObj = {};
      result.forEach(group => {
          group.images.forEach(imageItem => {
            imageObj = {
              imageType: group.groupType,
              imageId: imageItem.id,
              imageLink: imageItem.imageLink,
              end_user_order_id: group.groupId,
              end_user_id: group.endUserId,
              end_user_login: group.endUserLogin,
              order_start_time: group.endUserOrderStartTime,
              order_finish_time: group.endUserOrderFinishTime,
              service_request_workflow_status: group.service_request_workflow_status,
              service_request_timestamp: group.timestamp,
            };
            arr.push(imageObj);
          });
        }
      );

      this.latestOrderPhotos.next(arr);
    });

    this.subscriptions.push(
      this.settingWindowOptionsService.isMaximized.pipe(
        delay(1000),
        filter(
          mapHeight => mapHeight !== null
        )
      ).subscribe(() => {
        if (this.map) {
          this.map.invalidateSize();
        }
      }));
    this.subscriptions.push(
      this.unitBehaviorSubject.subscribe(
        unit => {
          if (unit && unit.lastMsgUnit) {
            this.marker.next(MapHelper.createUnitMarker(unit));
          } else {
            this.marker.next(null);
          }
        }
      )
    );
    this.subscriptions.push(
      this.unitBehaviorSubject.subscribe(
        unit => this.loadingEvent.emit(!unit)
      )
    );
    this.subscriptions.push(
      combineLatest(
        this.trackTime,
        this.enableTrackFilter
      ).subscribe(
        ([trackTime, enableTrackFilter]) => {
          this.trackMessages.next([]);
          if (trackTime[0] && trackTime[1]) {
            const timestampFrom = moment(trackTime[0]).unix().toString();
            const timestampTo = moment(trackTime[1]).unix().toString();
            const unitId = this.unit.id;

            this.disableTrackTime = true;
            this.unitMessageService.getUnitMessages(unitId, timestampFrom, timestampTo, enableTrackFilter)
              .subscribe(
                r => {
                  this.trackMessages.next(
                    r.filter(m => m.lat !== 0 && m.lon !== 0)
                  );
                  this.disableTrackTime = false;
                  // this.track.next(p);
                },
                () => {
                  this.disableTrackTime = false;
                }
              );
          }
        }
      )
    );
    this.subscriptions.push(
      this.unitBehaviorSubject.pipe(
        filter(unit => !!unit),
        distinctUntilKeyChanged('id')
      ).subscribe(
        () => {
          this.trackTime.next([null, null]);
          if (this.leafletLbsCircle.value) {
            this.leafletLbsCircle.value.removeFrom(this.map);
            this.leafletLbsCircle.next(null);
          }
        }
      )
    );
    this.availableStatuses = this.unitBehaviorSubject.pipe(
      filter(unit => !!unit),
      distinctUntilChanged((x, y) => x.unit_type_name === y.unit_type_name),
      switchMap(
        unit => this.unitStatusManager.getStatusesForUnitType(unit.unit_type_name)
      )
    );
    this.endUserId = this.unitBehaviorSubject.pipe(
      map(
        unit => (unit.activeOrder && unit.activeOrder.endUser) ? unit.activeOrder.endUser.id : null
      )
    );
    this.endUserImage = this.endUserId.pipe(
      distinctUntilChanged(),
      switchMap(
        endUserId => {
          if (endUserId === null) {
            return of({image: '/assets/img/user.svg', title: 'No client profile photo'});
          } else {
            const params = (new HttpParams())
              .append('expand', 'end_user_photo,end_user_avatar')
              .append('fields', 'end_user_photo,end_user_avatar');
            return this.http.get(
              environment.apiBasepoint + 'end-user/' + endUserId.toString(),
              {params: params, observe: 'body'}
            ).pipe(
              map(
                (endUser: any) => {
                  return endUser.end_user_photo ?
                    {
                      image: 'data:image/jpeg;base64,' + endUser.end_user_photo,
                      title: 'Image',
                    }
                    : (
                      endUser.end_user_avatar ? {
                          image: 'data:image/jpeg;base64,' + endUser.end_user_avatar,
                          title: 'Image',
                        }
                        : {
                          image: 'assets/img/user.svg',
                          title: 'No client profile photo',
                        }
                    );
                }
              )
            );
          }
        }
      )
    );
  }

  ngOnDestroy(): void {
    this.stopRefresh();
    this.subscriptions.filter(s => !!s).map(s => s.unsubscribe());
    this.mainLightboxService.show.next(false);
    this.mainLightboxService.selectedImageIndex.next(null);
    this.mainLightboxService.images.next([]);
    this.latestOrderPhotos.next(null);
  }

  isMoving(): boolean {
    return this.speed > 2;
  }

  onMapReady(lmap: L.Map) {
    this.map = lmap;
    this.map.zoomControl.setPosition('bottomright');
    this.subscriptions.push(
      this.unitBehaviorSubject.pipe(
        distinctUntilKeyChanged('id')
      ).subscribe(
        unit => {
          this.initialMapView(unit);
        }
      )
    );

    this.layers = combineLatest(
      this.marker,
      this.track,
    ).pipe(
      map(
        ([
           marker,
           track,
         ]) => {
          const layers = [];
          if (marker !== null) {
            layers.push(marker);
          }
          if (track !== null) {
            layers.push(track);
          }
          return [...layers];
        }
      )
    );
    this.map.on('zoomend', (e) => {
      this.leafletZoom = this.map.getZoom();
      this.changeDetector.detectChanges();
    });
    this.leafletMapReady.next(this.map);
    this.subscriptions.push(
      this.settingWindowOptionsService.isMaximized.pipe(delay(300)).subscribe(() => {
        if (this.map) {
          this.map.invalidateSize();
        }
      }));
  }

  onTrackClick(e) {
    const a = MapHelper.getNearestTrackCoords(e.latlng.lat, e.latlng.lng, e.target.getLatLngs(), e.target.getLatLngs().length);
    const b = MapHelper.getNearestCoordsOfNearestTrack(e.latlng.lat, e.latlng.lng, a);
    const message = this.trackMessages.getValue().find(m => m.lat === b.lat && m.lon === b.lng);

    if (message && message.id) {
      const popup = new Popup({
        autoPanPadding: new Point(0, 0),
        offset: new Point(0, 0)
      })
        .setLatLng(b)
        .setContent(
          `<div>` +
          `<div><div>` + this.translates.instant('Time') + `:</div><div>` +
          formatDate(message.time * 1000, 'medium', this.locale) + `</div></div>` +
          `<div><div>` + this.translates.instant('Location') + `:</div><div>` + message.lat + `, ` + message.lon + `</div></div>` +
          `<div><div>` + this.translates.instant('Speed') + `:</div><div>` + message.speed + `</div></div>` +
          `<div><div>` + this.translates.instant('Satellites') + `:</div><div>` + message.sats + `</div></div>` +
          `</div>`
        )
        .openOn(this.map);
    }
  }

  searchByLbsClickEvent(unit: Unit) {
    if (!this.unitViewMode) {
      this.searchByLbsClickEmitter.emit(unit);
    } else {
      this.searchByLbsClick(unit);
    }
  }

  searchByLbsClick(unit: Unit) {
    if (this.leafletLbsCircle.value) {
      this.leafletLbsCircle.value.removeFrom(this.map);
    }
    this.leafletLbsCircle.next(null);
    this.lbsYandex.next(null);
    if (unit.lbsLac && unit.lbsCountryCode && unit.lbsOperatorId && unit.lbsCellId) {
      this.http.get(
        environment.apiBasepoint + 'geocode/lbs',
        {
          observe: 'body', params: (new HttpParams())
            .append('cellId', unit.lbsCellId.toString())
            .append('operatorId', unit.lbsOperatorId.toString())
            .append('countryCode', unit.lbsCountryCode.toString())
            .append('lac', unit.lbsLac.toString())
        }
      ).subscribe((body: LbsYandexModel) => {
        const toolTip = this.translates.instant('LBS coordinates') + ' ' + body.latitude + ', ' + body.longitude + '; '
          + this.translates.instant('precision') + ' ' + body.precision + ' ' + this.translates.instant('m.');
        const geofence = L.circle(L.latLng(body.latitude, body.longitude), body.precision).bindPopup(toolTip);
        this.map.setView(new LatLng(body.latitude, body.longitude), this.map.getZoom());
        this.leafletLbsCircle.next(geofence);
        geofence.addTo(this.map);
        body.unitId = unit.id;
        this.lbsYandex.next(body);
      });
    } else {
      this.notif.warn(this.translates.instant('LBS search'), this.translates.instant('Not enough data to search for LBS'));
    }
  }

  public parseUnitCoordinatesToLatLng(coords: string) {
    if (coords && this.trackMessages.getValue().length === 0 && !this.leafletLbsCircle.value) {
      const latlng = coords.split(',');
      return L.latLng(parseFloat(latlng[0]), parseFloat(latlng[1]));
    } else {
      return null;
    }
  }


  getOrderStatus(): string {
    switch (this.unit.status_order) {
      case 'free':
        return this.translates.instant('Free');
      case 'booked':
        return this.translates.instant('Booked');
      case 'active':
        return this.translates.instant('Active trip');
      case 'paused':
        return this.translates.instant('Pause');
      case 'in_service':
        return this.translates.instant('Hidden in the application');
    }
  }

  setTimeForTrackChange(type: string) {
    this.selectedTrackPeriod = type;
    const date: Date = new Date();

    switch (type) {
      case this.trackPeriodHour: {
        date.setHours(date.getHours() - 1);
        break;
      }
      case this.trackPeriodDay: {
        date.setDate(date.getDate() - 1);
        break;
      }
      case this.trackPeriodWeek: {
        date.setDate(date.getDate() - 7);
        break;
      }
      case this.trackPeriod30Days: {
        date.setDate(date.getDate() - 30);
        break;
      }
    }

    this.trackTime.next([date, new Date()]);
  }

  onDateTimeChange(event) {
    this.selectedTrackPeriod = null;
    this.trackTime.next(event.value);
  }

  get resetButtonIsVisible() {
    return this.trackTime && this.trackTime.getValue() && this.trackTime.getValue()[0] !== null && this.trackTime.getValue()[1] !== null;
  }

  filterByDate() {
    this.trackMessages.next([]);
  }

  openLightbox(orderId: number, imageId: number) {
    const params = (new HttpParams())
      .append('fields', 'id')
      .append('expand', 'image,order_start_time,order_finish_time,end_user_order_id,end_user_id');
    this.http.get(environment.apiBasepoint + 'order/' + orderId + '/image', {params: params})
      .subscribe((images: Array<object>) => {
        const album = images.map(image => ({src: 'data:image/jpeg;base64,' + image['image'], id: image['id']}));
        const index = images.findIndex(image => image['id'] === imageId);
        this.mainLightboxService.open(album, index);
      });
  }

  onStatusChange(statusId) {
    const newStatusId: number = statusId;
    this.unitStatusVisibility = false;
    const oldStatusId = this.unit.unit_status_id;
    if (oldStatusId !== newStatusId) {
      const subscription = this.unitStatusManager.changeStatus(
        this.unit.id,
        this.unit.unit_type_name,
        oldStatusId,
        newStatusId
      ).subscribe(
        newStatus => {
          subscription.unsubscribe();
          if (newStatus.id === newStatusId) {
            const unit = lodash.cloneDeep(this.unitBehaviorSubject.getValue());
            unit.unit_status_id = newStatusId;
            this.unitBehaviorSubject.next(unit);
            this.notif.success(this.translates.instant('Saved'));
          }
        }
      );
    }
  }

  commandClick(unit: Unit, command: any) {
    const commandSubscription = this.unitStatusManager
      .needToChangeStatusWhenSendingCommand(unit.unitModel.unit_type_name, unit.unit_status_id, command.id)
      .pipe(
        switchMap(
          (result: Array<UnitStatusModel> | boolean) => {
            if (typeof result === 'boolean') {
              return this.modalWindowService.showWindow({
                modalWindowType: ModalWindowType.Confirmation,
                text: this.translates.instant('Do you wish to send command') + ' "' + command.command_name + '"?'
              });
            } else {
              return this.modalWindowService.showWindow({
                modalWindowType: ModalWindowType.Selection,
                text: this.translates.instant('Do you wish to change status and send command') + ' "' + command.command_name + '"?',
                selectParameters: {
                  items: result,
                  keyField: 'id',
                  displayedField: 'translatedDescription',
                }
              });
            }
          }
        ),
        switchMap(
          (result: ModalWindowResponse) => {
            if (result.confirmed && !result.selectionResult) {
              return this.http.patch(
                environment.apiBasepoint + 'unit/' + unit.id.toString() + '/command/' + command.id,
                {send: true},
                {observe: 'body'}
              );
            } else if (result.confirmed && result.selectionResult) {
              const requestBody = {
                unit_status_id: result.selectionResult
              };
              return this.http.patch(
                environment.apiBasepoint + 'unit/' + this.unit.id.toString(),
                requestBody
              );
            } else {
              return of(false);
            }
          }
        )
      ).subscribe(
        (result: any) => {
          if (result && result.unit_status_id) {
            const unitClone = lodash.cloneDeep(this.unitBehaviorSubject.getValue());
            unitClone.unit_status_id = result.unit_status_id;
            this.unitBehaviorSubject.next(unitClone);
            this.notif.success(this.translates.instant('Saved'));
          } else if (result) {
            this.notif.success(this.translates.instant('Command sent'));
          }
          commandSubscription.unsubscribe();
        }
      );
  }

  onNewUnitStatusId(unitStatusId) {
    const unitClone = lodash.cloneDeep(this.unitBehaviorSubject.getValue());
    unitClone.unit_status_id = unitStatusId;
    this.unitBehaviorSubject.next(unitClone);
    this.notif.success(this.translates.instant('Saved'));
  }

  startRefresh(unitId: number) {
    const pollDataObservable = this.unitCardDataService.getUnitData(unitId).pipe(
      tap(unitData => this.unitBehaviorSubject.next(unitData))
    );
    this.pollDataSubscription = pollDataObservable.pipe(
      expand(() =>
        timer(this.refreshInterval)
          .pipe(concatMap(() => pollDataObservable))
      )
    ).subscribe();
  }


  stopRefresh() {
    if (this.pollDataSubscription) {
      this.pollDataSubscription.unsubscribe();
    }
  }

  filterCoordinateBtnTitle(value: boolean) {
    return value ? 'Disable coordinate outlier filtering' : 'Enable filtering of new coordinates';
  }

  showPricePlans() {
    return this.unit.unitType.name !== Unit.UNIT_TYPE_TRACKER
      && this.unit.unitType.name !== Unit.UNIT_TYPE_IOT
      && (!this.unit.prepaidPricePlans || this.unit.prepaidPricePlans.length === 0)
    ;
  }
  showPrepaidPricePlans() {
    return this.unit.prepaidPricePlans && this.unit.prepaidPricePlans.length > 0;
  }
  showOrders() {
    return this.unit.unitType.name !== Unit.UNIT_TYPE_TRACKER
      && this.unit.unitType.name !== Unit.UNIT_TYPE_IOT;
  }
}
